export const parseDuration = (duration: string): number => {
  const match = duration.match(/^([\d.]+)s$/);
  return match ? parseFloat(match[1]) : 0;
};

const formatUnit = (value: number, divisor: number, unit: string): string => {
  const hasRemainder = value % divisor !== 0;
  if (hasRemainder) {
    const formatted = (value / divisor).toFixed(1);
    if (formatted.endsWith('.0')) {
      const whole = parseInt(formatted, 10);
      return `${whole} ${unit}${whole !== 1 ? 's' : ''}`;
    }
    return `${formatted} ${unit}s`;
  }
  const whole = value / divisor;
  return `${whole} ${unit}${whole !== 1 ? 's' : ''}`;
};

export const formatDuration = (seconds: number): string => {
  if (seconds < 60) {
    return `${seconds} second${seconds !== 1 ? 's' : ''}`;
  }
  if (seconds < 3600) {
    return formatUnit(seconds, 60, 'minute');
  }
  if (seconds < 86400) {
    return formatUnit(seconds, 3600, 'hour');
  }
  return formatUnit(seconds, 86400, 'day');
};
